"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Canvas = void 0;
var _paper = _interopRequireDefault(require("paper"));
var _Canvas = require("../../CanvasInterface/Canvas");
var _Group = require("./Objects/Group");
var _Image = require("./Objects/Image");
var _Text = require("./Objects/Text");
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
var _UseMask = require("./Utils/UseMask");
var _TextToSVGRepository = require("./Utils/TextToSVGRepository");
var _HTML2Paper = require("./Utils/HTML2Paper");
var _SVGfix = require("./Utils/SVGfix");
var _UseColorLayer = require("./Utils/UseColorLayer");
var _excluded = ["type"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('Canvas');
var Canvas = exports.Canvas = /*#__PURE__*/function (_AbstractCanvas) {
  _inherits(Canvas, _AbstractCanvas);
  var _super = _createSuper(Canvas);
  function Canvas() {
    var _this;
    _classCallCheck(this, Canvas);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_project", void 0);
    _defineProperty(_assertThisInitialized(_this), "_view", void 0);
    // prevents dragging out the object (by default lets dragging only up to the 2/3 of the object width)
    _defineProperty(_assertThisInitialized(_this), "_boundTolerance", 1 / 2 - 2 / 3);
    _defineProperty(_assertThisInitialized(_this), "_maskHandler", undefined);
    _defineProperty(_assertThisInitialized(_this), "_colorOverlay", undefined);
    _defineProperty(_assertThisInitialized(_this), "getScreenshot", function () {
      // speed up repeated screenshot creation by memoizing the svg output of Paper.js
      var memoizedSvgStr;
      var result;
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function (fontToFileMap) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var _options$memoize, memoize, svgStr, xmlDoc, xmlStr;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _options$memoize = options.memoize, memoize = _options$memoize === void 0 ? true : _options$memoize;
                  svgStr = (0, _SVGfix.prepareSvgStr)(_this._project.exportSVG({
                    asString: true,
                    embedImages: false
                  }));
                  if (!(memoize && memoizedSvgStr === svgStr && result)) {
                    _context.next = 4;
                    break;
                  }
                  return _context.abrupt("return", result);
                case 4:
                  result = '';
                  xmlDoc = new DOMParser().parseFromString(svgStr, 'text/xml');
                  (0, _HTML2Paper.removePlaceholders)(xmlDoc);
                  _context.next = 9;
                  return (0, _TextToSVGRepository.transformTextToPath)(xmlDoc, fontToFileMap);
                case 9:
                  (0, _SVGfix.wrapWithViewGroup)(xmlDoc);
                  if (_this._maskHandler) {
                    _this._maskHandler.fixSVGExport(xmlDoc);
                  }
                  xmlStr = new XMLSerializer().serializeToString(xmlDoc);
                  result = (0, _SVGfix.fixSvgExportResult)(xmlStr);
                  if (memoize) {
                    memoizedSvgStr = svgStr;
                  }
                  return _context.abrupt("return", result);
                case 15:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })();
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }());
    return _this;
  }
  _createClass(Canvas, [{
    key: "setBoundTolerance",
    value: function setBoundTolerance(value) {
      this._boundTolerance = value;
    }
  }, {
    key: "init",
    value: function init(canvasElement) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var canvas = canvasElement || this.createCanvasElement();
      this._project = _paper["default"].setup(canvas).project;
      this._view = this._project.view;
      this._project.activeLayer.name = 'designerLayer';
      this.initControls();
      _get(_getPrototypeOf(Canvas.prototype), "init", this).call(this, this._view.element, options);
    }
  }, {
    key: "initControls",
    value: function initControls() {
      this._view.onMouseDown = this.onMouseDown.bind(this);
      this._view.onMouseDrag = this.onMouseDrag.bind(this);
      this._view.onMouseUp = this.onMouseUp.bind(this);
      this._view.on('keydown', this.onKeyDown.bind(this));
    }
  }, {
    key: "activate",
    value: function activate() {
      this._project && this._project.activate();
    }
  }, {
    key: "update",
    value: function update() {
      // for some older browsers the canvas has to be added to the dom to draw the fonts correctly
      var forceUpdate = this.addToContainer();
      // important: at the time of this code was created, there was no way to force the update (redrawing of canvas items)
      // as a workaround the view._needsUpdate flag can be set to true
      // see https://github.com/paperjs/paper.js/commit/8174405924fde12488b73dbf58a70ceef4f57665 for updates
      this._view._needsUpdate = this._view._needsUpdate || forceUpdate;
      this._view.update();
      forceUpdate && this.removeFromContainer();
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._view.remove();
      this._view = null;
      this._project.remove();
      this._project = null;
      _get(_getPrototypeOf(Canvas.prototype), "dispose", this).call(this);
    }
  }, {
    key: "setSize",
    value: function setSize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSize();
      _get(_getPrototypeOf(Canvas.prototype), "setSize", this).call(this, size);
      this.updateViewSize();
      return this;
    }
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {
      _get(_getPrototypeOf(Canvas.prototype), "setZoom", this).call(this, zoom);
      this.updateViewSize();
      return this;
    }
  }, {
    key: "updateViewSize",
    value: function updateViewSize() {
      var zoom = this.zoom,
        _this$size = this.size,
        width = _this$size.width,
        height = _this$size.height;
      var w = width * zoom;
      var h = height * zoom;
      var size = new _paper["default"].Size(w, h);
      this._view.zoom = zoom;
      this._view.center = new _paper["default"].Point(this._view.size.divide(2));
      this._view.viewSize = size;
      this._maskHandler && this._maskHandler.updateOutline();
      this.updateObjectConstraints();
    }
  }, {
    key: "saveViewBox",
    value: function saveViewBox() {
      var _this2 = this;
      var _this$_view = this._view,
        viewSize = _this$_view.viewSize,
        center = _this$_view.center,
        zoom = _this$_view.zoom;
      return function () {
        _this2._view.viewSize = viewSize;
        _this2._view.center = center;
        _this2._view.zoom = zoom;
      };
    }
  }, {
    key: "setViewBox",
    value: function setViewBox(_ref2) {
      var width = _ref2.width,
        height = _ref2.height,
        x = _ref2.x,
        y = _ref2.y,
        zoom = _ref2.zoom;
      this._view.viewSize = new _paper["default"].Size(width, height);
      this._view.center = new _paper["default"].Point((x + width / 2) / zoom, (y + height / 2) / zoom);
      this._view.zoom = zoom;
      this.update();
    }
  }, {
    key: "drawToContext",
    value: function () {
      var _drawToContext = _asyncToGenerator(function (ctx, dx, dy, dWidth, dHeight) {
        var _this3 = this;
        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var TILE_SIZE, currentZoom, restoreViewBox, dstSize, srcSize, zoom, framesX, framesY, tiles, _loop, fx;
          return _regeneratorRuntime().wrap(function _callee2$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                TILE_SIZE = 512; // safe for ios
                currentZoom = Math.min(Math.max(options.currentZoom || 1, 0.0001), 1);
                restoreViewBox = _this3.saveViewBox();
                dstSize = TILE_SIZE;
                srcSize = Math.round(TILE_SIZE * currentZoom);
                zoom = dWidth / _this3.getSize().width * currentZoom;
                framesX = Math.floor(dWidth / dstSize) + 1;
                framesY = Math.floor(dHeight / dstSize) + 1;
                tiles = [];
                _this3._maskHandler && _this3._maskHandler.updateOutline({
                  getZoomFactor: function getZoomFactor() {
                    return zoom;
                  }
                });
                _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(fx) {
                  var _loop2, fy;
                  return _regeneratorRuntime().wrap(function _loop$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2(fy) {
                          return _regeneratorRuntime().wrap(function _loop2$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                tiles.push(new Promise(function (resolve) {
                                  window.requestAnimationFrame(function () {
                                    _this3.setViewBox({
                                      width: srcSize,
                                      height: srcSize,
                                      x: srcSize * fx,
                                      y: srcSize * fy,
                                      zoom: zoom
                                    });
                                    ctx.drawImage(_this3.canvasElement, dx + dstSize * fx, dy + dstSize * fy, dstSize, dstSize);
                                    resolve();
                                  });
                                }));
                              case 1:
                              case "end":
                                return _context2.stop();
                            }
                          }, _loop2);
                        });
                        fy = 0;
                      case 2:
                        if (!(fy < framesY)) {
                          _context3.next = 7;
                          break;
                        }
                        return _context3.delegateYield(_loop2(fy), "t0", 4);
                      case 4:
                        fy++;
                        _context3.next = 2;
                        break;
                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }, _loop);
                });
                fx = 0;
              case 12:
                if (!(fx < framesX)) {
                  _context4.next = 17;
                  break;
                }
                return _context4.delegateYield(_loop(fx), "t0", 14);
              case 14:
                fx++;
                _context4.next = 12;
                break;
              case 17:
                _context4.next = 19;
                return Promise.all(tiles);
              case 19:
                restoreViewBox();
              case 20:
              case "end":
                return _context4.stop();
            }
          }, _callee2);
        })();
      });
      function drawToContext(_x2, _x3, _x4, _x5, _x6) {
        return _drawToContext.apply(this, arguments);
      }
      return drawToContext;
    }()
  }, {
    key: "setSelectedColor",
    value: function setSelectedColor(color) {
      this._project && this._project.activeLayer.setSelectedColor(color);
      return this;
    }
  }, {
    key: "useMask",
    value: function () {
      var _useMask2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(maskData) {
        return _regeneratorRuntime().wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = Object;
              _context5.t1 = this._maskHandler || {};
              _context5.next = 4;
              return (0, _UseMask.useMask)(this._project, maskData);
            case 4:
              _context5.t2 = _context5.sent;
              this._maskHandler = _context5.t0.assign.call(_context5.t0, _context5.t1, _context5.t2);
              return _context5.abrupt("return", this._maskHandler);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee3, this);
      }));
      function useMask(_x7) {
        return _useMask2.apply(this, arguments);
      }
      return useMask;
    }()
  }, {
    key: "getMaskHandler",
    value: function getMaskHandler() {
      return this._maskHandler;
    }
  }, {
    key: "useColorOverlay",
    value: function useColorOverlay(colorLayerData) {
      this._colorOverlay = (0, _UseColorLayer.useColorLayer)(this._project, colorLayerData);
      return this._colorOverlay;
    }
  }, {
    key: "getColorOverlay",
    value: function getColorOverlay() {
      return this._colorOverlay;
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      var point = event.point;
      var hitResult = this._project.hitTest(point);
      if (hitResult) {
        var item = hitResult.item;
        var wo = this.getWrapperObject(this.getTopParent(item));
        if (this.selectedObject && wo !== this.selectedObject) {
          this.clearSelection();
        }
        if (wo) {
          wo.selected = true;
          wo.grabbed = true;
        }
      } else if (this.selectedObject) {
        this.clearSelection();
      }
    }
  }, {
    key: "onMouseDrag",
    value: function onMouseDrag(event) {
      if (this.selectedObject && !this.selectedObject.locked && !this.selectedObject.autoFit) {
        var _event$delta = event.delta,
          dx = _event$delta.x,
          dy = _event$delta.y;
        var o = this.selectedObject;
        o.x += dx;
        o.y += dy;
        this.fitBounds(o);
      }
    }
  }, {
    key: "fitBounds",
    value: function fitBounds(o) {
      var _this$size2 = this.size,
        cw = _this$size2.width,
        ch = _this$size2.height;
      var _o$getScaledSize = o.getScaledSize(),
        ow = _o$getScaledSize.width,
        oh = _o$getScaledSize.height;
      var leftMin = ow * this._boundTolerance;
      var leftMax = cw - leftMin;
      var topMin = oh * this._boundTolerance;
      var topMax = ch - topMin;
      if (o.x < leftMin) {
        o.x = leftMin;
      } else if (o.x > leftMax) {
        o.x = leftMax;
      }
      if (o.y < topMin) {
        o.y = topMin;
      } else if (o.y > topMax) {
        o.y = topMax;
      }
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      if (this.selectedObject) {
        this.selectedObject.grabbed = false;
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (['INPUT', 'SELECT'].indexOf(event.event.target.nodeName) === -1 && this.selectedObject) {
        var o = this.selectedObject;
        if (event.event.ctrlKey) {
          switch (event.key) {
            case 'up':
              o.scaling += 0.1;
              break;
            case 'right':
              o.rotation += 1;
              break;
            case 'down':
              o.scaling -= 0.1;
              break;
            case 'left':
              o.rotation -= 1;
              break;
          }
        } else {
          switch (event.key) {
            // translate
            case 'up':
              o.y -= 1;
              break;
            case 'right':
              o.x += 1;
              break;
            case 'down':
              o.y += 1;
              break;
            case 'left':
              o.x -= 1;
              break;
            // remove
            case 'delete':
              o.remove();
              break;
          }
        }
      }
    }
  }, {
    key: "getTopParent",
    value: function getTopParent(item) {
      var el = item;
      while (el.parent && el.parent !== item.layer) {
        el = el.parent;
      }
      return el;
    }
  }, {
    key: "getElementSize",
    value: function getElementSize() {
      if (this._view) {
        var _this$_view$getViewSi = this._view.getViewSize(),
          width = _this$_view$getViewSi.width,
          height = _this$_view$getViewSi.height;
        return {
          width: width,
          height: height
        };
      } else {
        return {
          width: 0,
          height: 0
        };
      }
    }
  }, {
    key: "setObjectIndex",
    value: function setObjectIndex(obj, pos) {
      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      _get(_getPrototypeOf(Canvas.prototype), "setObjectIndex", this).call(this, obj, pos, overwrite);
      var layer = this._project.activeLayer;
      layer.removeChildren(layer.firstChild.isClipMask() ? 1 : 0);
      layer.addChildren(this.objects.map(function (o) {
        return o && o.wrappedObject;
      }));
    }
  }, {
    key: "add",
    value: function add(obj) {
      _get(_getPrototypeOf(Canvas.prototype), "add", this).call(this, obj);
      if (obj.wrappedObject) {
        // make sure the object is added to the active layer of the associated project
        obj.wrappedObject.addTo(this._project.activeLayer);
      }
      return this;
    }
  }, {
    key: "addText",
    value: function addText(options) {
      var text = new _Text.Text(options);
      this.add(text);
      return text;
    }
  }, {
    key: "addImage",
    value: function () {
      var _addImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
        var src, image;
        return _regeneratorRuntime().wrap(function _callee4$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              src = options.src;
              image = new _Image.Image(options);
              if (!src) {
                _context6.next = 5;
                break;
              }
              _context6.next = 5;
              return image.loadFromURL(src);
            case 5:
              this.add(image);
              logger.log('Image has been added.', image);
              return _context6.abrupt("return", image);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee4, this);
      }));
      function addImage(_x8) {
        return _addImage.apply(this, arguments);
      }
      return addImage;
    }()
  }, {
    key: "addGroup",
    value: function () {
      var _addGroup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
        var src, group;
        return _regeneratorRuntime().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              src = options.src;
              group = new _Group.Group(options);
              if (!src) {
                _context7.next = 5;
                break;
              }
              _context7.next = 5;
              return group.loadFromURL(src);
            case 5:
              this.add(group);
              logger.log('Group has been added.', group);
              return _context7.abrupt("return", group);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee5, this);
      }));
      function addGroup(_x9) {
        return _addGroup.apply(this, arguments);
      }
      return addGroup;
    }()
  }, {
    key: "addItemFromObject",
    value: function () {
      var _addItemFromObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(options, index, overwrite) {
        var type, props, object;
        return _regeneratorRuntime().wrap(function _callee6$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              type = options.type, props = _objectWithoutProperties(options, _excluded);
              _context8.t0 = type;
              _context8.next = _context8.t0 === 'Image' ? 4 : _context8.t0 === 'Group' ? 8 : _context8.t0 === 'Text' ? 12 : 14;
              break;
            case 4:
              _context8.next = 6;
              return this.addImage(props);
            case 6:
              object = _context8.sent;
              return _context8.abrupt("break", 16);
            case 8:
              _context8.next = 10;
              return this.addGroup(props);
            case 10:
              object = _context8.sent;
              return _context8.abrupt("break", 16);
            case 12:
              object = this.addText(props);
              return _context8.abrupt("break", 16);
            case 14:
              logger.error('Unknown type: ' + type);
              return _context8.abrupt("return");
            case 16:
              if (typeof index === 'number') {
                object.setIndex(index, overwrite);
              }
              return _context8.abrupt("return", object);
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee6, this);
      }));
      function addItemFromObject(_x10, _x11, _x12) {
        return _addItemFromObject.apply(this, arguments);
      }
      return addItemFromObject;
    }()
  }, {
    key: "getScreenshotsOfElements",
    value: function () {
      var _getScreenshotsOfElements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(fontToFileMap) {
        var svgStr, xmlDoc, designerLayer, elements, _iterator, _step, element, xmlSerializer, screenshots, _iterator2, _step2, _element;
        return _regeneratorRuntime().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.getScreenshot(fontToFileMap, {
                memoize: false
              });
            case 2:
              svgStr = _context9.sent;
              xmlDoc = new DOMParser().parseFromString(svgStr, 'text/xml');
              designerLayer = xmlDoc.getElementById('designerLayer');
              if (designerLayer) {
                _context9.next = 7;
                break;
              }
              return _context9.abrupt("return", []);
            case 7:
              elements = _toConsumableArray(designerLayer.children); // remove all elements from the active layer
              _iterator = _createForOfIteratorHelper(elements);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  element = _step.value;
                  designerLayer.removeChild(element);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              xmlSerializer = new XMLSerializer();
              screenshots = []; // add elements one-by-one to export SVGs of them
              _iterator2 = _createForOfIteratorHelper(elements);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _element = _step2.value;
                  designerLayer.appendChild(_element);
                  screenshots.push(xmlSerializer.serializeToString(xmlDoc));
                  designerLayer.removeChild(_element);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return _context9.abrupt("return", screenshots);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee7, this);
      }));
      function getScreenshotsOfElements(_x13) {
        return _getScreenshotsOfElements.apply(this, arguments);
      }
      return getScreenshotsOfElements;
    }()
  }]);
  return Canvas;
}(_Canvas.AbstractCanvas);